import React from "react"
import Hero from "./Hero"
import CompanyInformation from "./CompanyInformation"
import Image from "./Image"
import Problem from "./Problem"
import Design from "./Design"
import Contact from "components/Contact"
import Footer from "components/Footer"
import Technology from "./Technology"
import { Helmet } from "react-helmet"

export const CaseStudyContext = React.createContext()

class CaseStudy extends React.Component {
  render() {
    const {
      caseStudy,
      renderSummary,
      renderProblem,
      renderDesign,
      renderTechnology,
      renderProjectLogo,
      renderCompanyLogo,
      imageStyles,
      heroBackgroundOpacity,
      heroBackgroundColor,
    } = this.props

    return (
      <CaseStudyContext.Provider value={caseStudy}>
        <Helmet>
          <title>{`Case Study för ${caseStudy.title.toLowerCase()}`}</title>
          <meta name="description" content={caseStudy.metaDescription} />
        </Helmet>
        <Hero
          renderProjectLogo={renderProjectLogo}
          backgroundColor={heroBackgroundColor}
          backgroundOpacity={heroBackgroundOpacity}
        />
        <CompanyInformation
          renderSummary={renderSummary}
          renderCompanyLogo={renderCompanyLogo}
        />
        <Problem
          renderProblem={renderProblem}
          wrap={caseStudy.imageSectionImage ? true : false}
        />
        {caseStudy.imageSectionImage && (
          <Image
            image={caseStudy.imageSectionImage}
            altText={caseStudy.imageSectionImageAltText}
            imageStyles={imageStyles}
          />
        )}
        <Design
          renderDesign={renderDesign}
          wrap={caseStudy.imageSectionImage ? true : false}
        />
        <Technology renderTechnology={renderTechnology} />
        <Contact />
        <Footer />
      </CaseStudyContext.Provider>
    )
  }
}

export default CaseStudy



// WEBPACK FOOTER //
// ./src/components/CaseStudy/index.jsx